import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks";
import GenerateImageIcon from "../../../../Custom-imeges/GenerateImageIcon";
import DownloadIcon from "../../../../Custom-imeges/DownloadIcon";
import { handleDownload } from "../../../../store/one-query/useMethodHelper";

interface ImageGenerationProps {
    imageSrc: string;
    canDownload?: boolean;
    source?:string;
}
const ImageGeneration = ({imageSrc,canDownload,source}:ImageGenerationProps) => {
  const [isHoverImage, setIsHoverImage] = useState<boolean>(false);
  const chatNum = useAppSelector((s) => s.ChatsState.chatsNum);
  
  const handleDownloadImage = () => {
    if (imageSrc) {
      handleDownload(imageSrc)
  }
};
  if (!imageSrc) {
    // Show loader when generating the image
    return (
      <div
        className={`loader-wrapper d-flex justify-content-center align-items-center box-loading ${
          chatNum === 4 || chatNum === 6 ? "small-size" : "large-size"
        }`}
      >
        <CircularProgress
          className="image-loader"
          size="60px"
          value={100}
          thickness={1}
        />
        <div className="loader-content">
          <GenerateImageIcon className="custom-icon-color" />
          <div className="image-generate-word">Generate</div>
        </div>
      </div>
    );
  }

  if (imageSrc) {
    // Show the image when imageSrc contains data
    return (
      <div
        className={`image-generation-container`}
        onMouseEnter={() => setIsHoverImage(true)}
        onMouseLeave={() => setIsHoverImage(false)}
      >
        <img
          className={`image-generated`}
          src={imageSrc}
          alt="Generated"
        />
        <div
          className={`download-icon ${
            chatNum === 4 || chatNum === 6 ? "small-size" : "large-size" 
          }
            ${source==="imageUpload" ?"imageUpload":""}
          `}
          onClick={handleDownloadImage}
        >
          {isHoverImage&& <DownloadIcon className={`hover-icon`} />}
        </div>
      </div>
    );
  }
  return null;
};

export default ImageGeneration;
